import { IOpData, IReferenceType, IOpChangeState, IOpObject } from '../util/interfaces'
import { Enums } from '../common/enums'
import { Utils } from '../util/utils'
import { DataProvider } from '../../helpers/data-provider'
import { Dictionary } from '../../helpers/dictionary'
import { CommonHelper } from '../../helpers/common-helper'
import { ObjectCustomString } from '../../models/util/object-custom-string'

import { OpDataList } from '../util/op-data-list'
import { OpDataType } from './op-data-type'
import { OpSimCardData } from './op-sim-card-data'


export class OpSimCard implements IReferenceType, IOpObject, IOpChangeState {
    //Properties
    public idSimCard: number
    public idDistributor: number
    public serialNbr: number
    public phone: string
    public pin: string
    public puk: string
    public mobileNetworkCode: number = null
    public ip: string
    public apnLogin: string
    public apnPassword: string
    //Properties end

    constructor(opObj: any) {
        this.fromJSON(opObj, false)
    }

    //IOpChangeState implementation
    public opState: Enums.OpChangeState
    //IOpChangeState implementation end
    //IReferenceType implementation
    public getReferenceType(): Enums.ReferenceType {
        return Enums.ReferenceType.IdSimCard
    }
    public getReferenceKey(): number {
        return this.idSimCard
    }
    public getReferenceValue(): any {
        return this
    }
    //IReferenceType implementation end
    //IOpObject implementation
    public get idObject(): any {
        return this.idSimCard
    }
    public set idObject(idObject: any) {
        this.idSimCard = idObject
    }

    public dataList: OpDataList<OpSimCardData> = new OpDataList<OpSimCardData>()

    public dynamicValues: { Key: string, Value: any }[] = []

    public customFormatString: string

    public fromJSON(opObj: any, compressed: boolean = false): void {
        if (opObj) {
            this.idSimCard = opObj.ID_SIM_CARD
            this.idDistributor = opObj.ID_DISTRIBUTOR
            this.serialNbr = opObj.SERIAL_NBR
            this.phone = opObj.PHONE
            this.pin = opObj.PIN
            this.puk = opObj.PUK
            this.mobileNetworkCode = opObj.MOBILE_NETWORK_CODE
            this.ip = opObj.IP
            this.apnLogin = opObj.APN_LOGIN
            this.apnPassword = opObj.APN_PASSWORD

            if (opObj.DataList)
                this.dataList.push(...opObj.DataList.map(data => new OpSimCardData(data)))
            else
                this.dataList = new OpDataList<OpSimCardData>()

            this.dynamicValues = opObj.dynamicValues

            this.opState = opObj.OpState
        }
    }

    public toJSON(compressed: boolean = false): any {
        return {
            ID_SIM_CARD: this.idSimCard,
            DataList: this.dataList ? this.dataList.ToJSON() : null,
            OpState: this.opState
        }
    }

    public toString() {
        var customFormatString = ObjectCustomString.getCustomStringFormat(this)
        if (!customFormatString) {
            return this.serialNbr + ''
        }
        else {
            return ObjectCustomString.getObjectCustomString(customFormatString, this)
        }
    }
    //IOpObject implementation end

    public static loadNavigationProperties(dataProvider: DataProvider, list: OpSimCard[]): JQueryPromise<OpSimCard[]> {
        return Utils.loadDataListNavigationProperties(dataProvider, list)
    }

    public static fromIOpObject(object: IOpObject): OpSimCard {
        var newObject: OpSimCard = new OpSimCard(null)
        newObject.idSimCard = object.idObject
        newObject.opState = object.opState
        newObject.dataList.push(...object.dataList.toArray().map((data: IOpData) => OpSimCardData.fromIOpData(data)))
        return newObject
    }
}